import { formatHours, TOUR_OF_DUTY_HOURS } from './scheduleDay'

/**
 * docs/product/scheduling-model.md's "Scheduled hours": totals shown by
 * week and by pay period, compared against the employee's tour of duty as
 * a warning, never enforced, "because a short or long period may be
 * correct." Used on the copy screen's review, saved-draft, and submitted
 * views, and on the calendar's Period view: every place that already shows
 * a full pay period's two weeks together.
 */
export default function HoursSummary({
  rows,
  total,
  compareToTourOfDuty = false,
}: {
  rows: { label: string; hours: number }[]
  total: number
  compareToTourOfDuty?: boolean
}) {
  const difference = total - TOUR_OF_DUTY_HOURS

  return (
    <div className="rounded-surface border border-line p-3">
      {rows.map((row) => (
        <div key={row.label} className="flex items-center justify-between text-small text-ink-muted">
          <span>{row.label}</span>
          <span className="font-bold text-ink">{formatHours(row.hours)}</span>
        </div>
      ))}
      <div
        className={`flex items-center justify-between text-small font-bold ${
          rows.length > 0 ? 'mt-1 border-t border-line pt-1' : ''
        }`}
      >
        <span>{rows.length > 0 ? 'Pay period total' : 'Scheduled'}</span>
        <span>{formatHours(total)}</span>
      </div>
      {compareToTourOfDuty && difference !== 0 && (
        <p className="mt-1 text-caption font-semibold text-warning">
          {formatHours(Math.abs(difference))} {difference > 0 ? 'more' : 'less'} than the{' '}
          {formatHours(TOUR_OF_DUTY_HOURS)} tour of duty.
        </p>
      )}
    </div>
  )
}
